import { validate } from 'uuid';

import { isFailureRequest, isStartRequest, isSuccessRequest } from 'modules/global/reducers/utils';
import { createReducer } from 'utils/ReduxUtils';

const initialState = [];

/**
 * @param {string[]} state
 * @param {import("modules/global/generic.types").Action<{ payerId: string }>} action
 * @returns {string[]}}
 */
const addOne = (state, { payload }) => [...state, payload.payerId];

/**
 * @param {string[]} state
 * @param {import("modules/global/generic.types").Action<string | { id: string, [field: string]: unknown }>} action
 * @returns {string[]}
 */
const removeFromSuccess = (state, { payload }) => {
  const entityId = validate(payload) ? payload : payload.id;
  return state.filter(id => entityId !== id);
};

/**
 * @param {string[]} state
 * @param {import("modules/global/generic.types").Action} action
 * @returns {string[]}
 */
const removeFromFailure = (state, { meta }) => state.filter(id => meta.entityId !== id);

const loading = (actionRoot, { config }) => createReducer(
  initialState,
  {},
  [
    {
      matcher: isStartRequest(actionRoot, config),
      reducer: addOne,
    },
    {
      matcher: isSuccessRequest(actionRoot, config),
      reducer: removeFromSuccess,
    },
    {
      matcher: isFailureRequest(actionRoot, config),
      reducer: removeFromFailure,
    },
  ]
);

export default loading;
